import { render, staticRenderFns } from "./PmRewardGrid.vue?vue&type=template&id=345869af"
import script from "./PmRewardGrid.vue?vue&type=script&lang=js"
export * from "./PmRewardGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports